import { graphql, useFragment } from "react-relay";
import { AHText, Box, Circle } from "arkh";
import { WidgetCalendarOverviewEventItem_event$key } from "./__generated__/WidgetCalendarOverviewEventItem_event.graphql";
import { CalendarOverviewEventItemDateTime } from "./CalendarOverviewEventItemDateTime";

export function WidgetCalendarOverviewEventItem(props: {
  event: WidgetCalendarOverviewEventItem_event$key;
  isActive: boolean;
}) {
  const event = useFragment(
    graphql`
      fragment WidgetCalendarOverviewEventItem_event on CalendarEvent {
        title
        storeCalendar {
          color
        }
        ...CalendarOverviewEventItemDateTime_event
      }
    `,
    props.event
  );

  return (
    <Box style={{ flexDirection: "row", alignItems: "baseline" }}>
      <Circle
        size="badge"
        style={{
          backgroundColor: event.storeCalendar.color,
        }}
      />
      <AHText type="subtitle" spaceLeft="small" style={{ flex: 1 }}>
        {event.title}
      </AHText>
      <AHText
        type="detail"
        spaceLeft="small"
        color={props.isActive ? "primary" : "text-secondary"}
      >
        <CalendarOverviewEventItemDateTime event={event} />
      </AHText>
    </Box>
  );
}
